import styled from "@emotion/styled";

export const StyledChipsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: flex-start;
  gap: ${({ theme }) => theme.spacing[2]};
  padding: 5px 0 0;
  width: 100%;
`;
